import type { Venue } from '../../types/venue';

export const roxResort: Venue = {
  id: 'rox-resort',
  name: 'Rox Resort',
  description: {
    en: `<p>Our conference facilities in Copenhagen are located near the coast, offering a unique blend of business and leisure. At Rox Resort, we curate an exceptional international experience where business seamlessly intertwines with pleasure and passion, all within a setting of timeless sophistication and social exploration.</p>
    
    <p>Indulge in coffee, conversations & coastal inspiration. Traditional meeting spaces are combined with a harmonious environment, providing that, work-life balance is key.</p>
    
    <p>Top-notch coffee, delectable snacks, and invigorating sea breezes that foster creativity as effortlessly as the ebb and flow of waves. Whether you're engaging in networking activities, brainstorming innovative ideas, or simply seeking a moment of introspection, our venue offers the perfect blend of business acumen amidst coastal tranquility.</p>`,
    
    sv: `<p>Våra konferensfaciliteter i Köpenhamn ligger nära kusten och erbjuder en unik blandning av affärer och fritid. På Rox Resort skapar vi en exceptionell internationell upplevelse där affärer sömlöst flätas samman med nöje och passion, allt inom en miljö av tidlös sofistikation och social utforskning.</p>
    
    <p>Njut av kaffe, konversationer och kustinspiration. Traditionella mötesplatser kombineras med en harmonisk miljö där balans mellan arbete och fritid är nyckeln.</p>
    
    <p>Förstklassigt kaffe, utsökta snacks och uppfriskande havsbris som främjar kreativitet lika enkelt som vågornas ebb och flod. Oavsett om du deltar i nätverksaktiviteter, brainstormar innovativa idéer eller bara söker en stund av självreflektion, erbjuder vår anläggning den perfekta blandningen av affärssinne i kustens lugn.</p>`,
    
    no: `<p>Våre konferansefasiliteter i København ligger nær kysten og tilbyr en unik blanding av forretninger og fritid. På Rox Resort skaper vi en eksepsjonell internasjonal opplevelse der forretninger sømløst sammenfaller med glede og lidenskap, alt innenfor en ramme av tidløs sofistikasjon og sosial utforskning.</p>
    
    <p>Nyt kaffe, samtaler og kystinspirasjon. Tradisjonelle møteplasser er kombinert med et harmonisk miljø, der balanse mellom arbeid og fritid er nøkkelen.</p>
    
    <p>Førsteklasses kaffe, deilige snacks og oppkvikkende sjøbris som fremmer kreativitet like enkelt som bølgenes ebbe og flod. Enten du deltar i nettverksaktiviteter, brainstormer innovative ideer eller bare søker et øyeblikk med introspeksjon, tilbyr vårt sted den perfekte blandingen av forretningsinnsikt i kystens ro.</p>`,
    
    da: `<p>Vores konferencefaciliteter i København er beliggende tæt på kysten og tilbyder en unik blanding af forretning og fritid. På Rox Resort skaber vi en exceptionel international oplevelse, hvor forretning sømløst flettes sammen med fornøjelse og passion, alt sammen i et miljø af tidløs sofistikation og social udforskning.</p>
    
    <p>Nyd kaffe, samtaler og kystinspiration. Traditionelle mødesteder kombineres med et harmonisk miljø, hvor balance mellem arbejde og fritid er nøglen.</p>
    
    <p>Førsteklasses kaffe, lækre snacks og forfriskende havbrise, der fremmer kreativitet lige så ubesværet som bølgernes ebbe og flod. Uanset om du deltager i netværksaktiviteter, brainstormer innovative idéer eller blot søger et øjeblik af selvrefleksion, tilbyder vores venue den perfekte blanding af forretningsmæssig skarphed midt i kystens ro.</p>`
  },
  image: '/assets/images/rox.jpg',
  country: 'dk',
  region: 'copenhagen',
  city: 'Copenhagen',
  address: 'Strandvejen 203, 2900 Hellerup, Denmark',
  coordinates: {
    lat: 55.47295526281213,
    lng: 12.19548395538388
  },
  capacity: {
    min: 5,
    max: 300
  },
  rating: 4.8,
  reviews: Array.from({ length: 220 }, (_, i) => ({
    id: `review-${i}`,
    userId: `user-${i}`,
    rating: 4.8,
    comment: '',
    date: new Date().toISOString()
  })),
  amenities: ['wifi', 'coffee', 'restaurant', 'spa', 'pool'],
  images: [
    '/assets/images/rox.jpg',
    'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&q=80&w=2000'
  ],
  priceRange: {
    min: 4000,
    max: 40000
  },
  recommended: false,
  factbox: {
    rooms: 158,
    conferenceRooms: 8,
    meetingCapacity: 300,
    features: [
      'Oceanfront location',
      '3 Boardrooms for smaller groups',
      '3 Medium-sized venues',
      '2 Larger venues for significant gatherings',
      'One XL venue',
      'Pool Club & Spa',
      '2 Restaurants',
      'Concierge service',
      '158 Rooms & 168 Balconies'
    ]
  }
}; 